// eslint-disable-next-line @github-ui/github-monorepo/filename-convention
export default `
uniform float uWidth;
uniform float uRadius;
uniform float uMaxRadius;
uniform float uMinRadius;
uniform float uWindowScale;
uniform vec2 uAlphaRange;

varying vec2 vUv;
varying float vAngle;
varying float vAlpha;

const float PI = 3.14159265359;
void main(){
  vUv = uv;
  vec3 pos = position;

  float angle = uv.y * PI * 2.0;


  float radius = mix(uRadius - uWidth * 0.5, uRadius + uWidth * 0.5, uv.x);
  pos.x = cos(angle) * radius;
  pos.y = sin(angle) * radius;

  vAngle = (1.0 - uv.y) * PI * 2.0;

  vAlpha = smoothstep(uMaxRadius * uAlphaRange.x, uMaxRadius * uAlphaRange.y, length(pos));
  vAlpha *= smoothstep(uMinRadius * 1.0, uMinRadius * 1.1, length(pos));

  pos.xy *= uWindowScale;


  gl_Position = projectionMatrix * viewMatrix * modelMatrix * vec4(pos, 1.0);
}
`
